import { Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { DeliveryLocation } from 'src/app/api/contracts/location';
import { ClientService } from 'src/app/services/client.service';

@Component({
  selector: 'app-delivery-selector',
  templateUrl: './delivery-selector.component.html',
  styleUrls: ['./delivery-selector.component.scss'],
})
export class DeliverySelectorComponent implements OnInit {
  @Input() public location: DeliveryLocation | null = null;
  @Input() isInstoreMode = false;

  constructor() {}

  ngOnInit() {
    return;
  }
}
